import { AttributeName, AttributeValue } from '@app/components/various/Matrix/MatrixContents/Attribute';
import { VariantImage } from '@app/components/various/Matrix/MatrixContents/VariantImage';
import { VariantInfo } from '@app/components/various/Matrix/MatrixContents/VariantInfo';
import { useProductConfiguration } from '@app/utils/hooks/matrix/useProductConfiguration';
import { isEmpty } from '@app/utils/isEmpty';
import { Product } from '@typings';

import { useMatrixSettingsContext } from '../context';

interface Props {
  variant: Product.Standard;
  shouldShowRrp?: boolean;
}

export const MatrixVariantInfo = ({ variant, shouldShowRrp }: Props) => {
  const { productConfiguration } = useMatrixSettingsContext();
  const { configurationAttributeTypes, configurationAttributeValuesPerVariant } = useProductConfiguration({
    productConfiguration,
    variants: [variant],
  });

  const gridStyles = { gridTemplateColumns: `repeat(${configurationAttributeTypes.length}, minmax(5rem,1fr))` };

  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex gap-3">
        <VariantImage variant={variant} />
        <VariantInfo variant={variant} shouldShowRrp={shouldShowRrp} />
      </div>

      {!isEmpty(configurationAttributeTypes) && (
        <div className="grid" style={gridStyles}>
          {configurationAttributeTypes.map(({ key, name, attributesDetails }, index) => (
            <div key={key}>
              <AttributeName name={name} attributesDetails={attributesDetails} />
              <AttributeValue value={configurationAttributeValuesPerVariant[0]?.[index] ?? ''} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
